"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Chooser = exports.choose = exports.fat = void 0;
// Fast Accounting Translation
function fat(originalStr, variant) {
    console.log(originalStr, variant);
    return originalStr;
}
exports.fat = fat;
function choose(props) {
    var UILanguage = globalThis.UILanguage;
    if (UILanguage) {
        return props[UILanguage] || "";
    }
    return "";
}
exports.choose = choose;
function Chooser(props) {
    var UILanguage = globalThis.UILanguage;
    if (UILanguage) {
        return props.options[UILanguage] || null;
    }
    return null;
}
exports.Chooser = Chooser;
